// TaskItem Component

/* eslint react/jsx-indent: 0,
  indent: 0 */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import app from '../../../app.jsx'
import IconButton from '../../../theme/common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import Util from '../../../lib/util.jsx'
import Checkbox from '../../../common/form/checkbox/checkbox.jsx'
import TaskSubtask from '../task_subtask/task_subtask.jsx'
import TimeClock from '../../../time/time/time_clock/time_clock.jsx'
import Avatar from '../../../common/common/avatar/avatar.jsx'
import Acl from '../../../lib/acl.jsx'
import timerStates from '../../../../shared/util/timer/timerStates.js'
class TaskItem extends Component {
  static get propTypes () {
    return {
      task: PropTypes.object,
      status: PropTypes.string,
      loggedInUserId: PropTypes.string,
      onCompleteTask: PropTypes.func,
      onAddTime: PropTypes.func,
      onStart: PropTypes.func,
      onPause: PropTypes.func,
      onResume: PropTypes.func,
      onClick: PropTypes.func,
      onCompleteSubtask: PropTypes.func,
      onClickSetting: PropTypes.func,
      onUpdateSubTasks: PropTypes.func,
      onToggleExpand: PropTypes.func,
      stopAndCreateNewTimeCard: PropTypes.func,
      timer: PropTypes.object.isRequired
    }
  }

  static get defaultProps () {
    return {
      task: null,
      status: '',
      loggedInUserId: null,
      onCompleteTask: null,
      onAddTime: null,
      onStart: null,
      onPause: null,
      onResume: null,
      onClick: null,
      onCompleteSubtask: null,
      onClickSetting: null,
      onUpdateSubTasks: null,
      onToggleExpand: null,
      stopAndCreateNewTimeCard: null
    }
  }

  constructor (props) {
    super(props)

    this.state = {
      expanded: false
    }

    this.data = {
      task: props.task
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    if (!_.isEqual(nextProps.task, this.props.task)) {
      const draftSubtask = _.find(
        this.data.task.subtasks,
        subtask => subtask.title === ''
      )

      const newTask = _.cloneDeep(nextProps.task)
      if (draftSubtask) {
        // For editing
        newTask.subtasks.push(draftSubtask)
      }

      this.data.task = newTask
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (prevState.expanded !== this.state.expanded) {
      if (this.props.onToggleExpand) {
        this.props.onToggleExpand()
      }
    }
  }

  render () {
    const { status, onClick } = this.props
    const task = this.data.task
    const expanded = this.state.expanded
    const className = `task-item${expanded ? ' expanded' : ''}`
    const phase = this._getPhase(task)
    const isTaskInActivePhase = phase ? phase.status === 'active' : true
    const isPageDashboard = app.request.pageIdent === 'dashboard'
    const showTask = isPageDashboard ? isTaskInActivePhase : true
    const phaseTitle = phase ? phase.title : ''
    const canEditAll = this._canEditAll()
    const canEditInfo = this._canEditInfo()
    const canAddTimecard = Acl.isRoleProjectManager() && task.userId
    const chkClassName = !task.completed ? 'taskcompleted' : 'taskcompleted_alt'
    const typeStatus = `task.item.status${task.priority}`
    const bAssignedUser = task.userId === this.props.loggedInUserId
    const timer = this.props.timer
    const noSubTasks = this._getNoOfSubtasks(task.subtasks)
    let showStart = false
    if (
      timer.isStartable() ||
      !timer.doesRelateToTaskId(task.id)
    ) {
      showStart = true
    }

    return showTask && (
      <div className={className}>
        {Acl.isStandardUser() ? null : (
          <div className='hovercont'>
            <IconButton
              size='small'
              icon='more'
              className='addmore'
              onClick={this._onClickSetting.bind(this)}
            />
          </div>
        )}
        <div className='taskcont' onClick={onClick ? this._onClick : null}>
          <div className='check' onClick={ev => ev.stopPropagation()}>
            {!task.completed && (
              <Avatar
                imageUrl={task.user ? task.user.imageUrl : ''}
                title={task.user ? task.user.displayName : ''}
              />
            )}
            <Checkbox
              checked={task.completed}
              disabled={!canEditAll}
              icon='dashboard'
              className={chkClassName}
              onChange={canEditAll ? this._onCompleteTask.bind(this) : null}
            />
          </div>
          <div className='inner'>
            <h4 className='title'>{task.title}</h4>
            {phase && phase.status !== 'estimate' && (
              <div className='action'>
                <span
                  className={`value${
                    task.priority ? ' value_' + task.priority.toLowerCase() : ''
                  }`}
                >
                  {task.priority && <IntlMessage ident={typeStatus} />}
                  {!task.priority && <span />}
                </span>
                {task.priority && <span className='split' />}
                {status === timerStates.NONE && showStart && bAssignedUser && (
                  <IconButton
                    icon='start'
                    type='primary'
                    title='task.item.timeResume'
                    disabled={!canEditInfo}
                    size='normal'
                    canHover={false}
                    className='tasktimming task-resume'
                    onClick={canEditInfo ? this._onStart.bind(this) : null}
                  />
                )}
                {status === timerStates.STARTED && (
                  <div className='innercont'>
                    <IconButton
                      icon='pause'
                      type='primary'
                      title='task.item.timePause'
                      disabled={!canEditInfo}
                      size='normal'
                      canHover={false}
                      className='taskpause'
                      onClick={canEditInfo ? this._onPause.bind(this) : null}
                    />
                  </div>
                )}
                {status === timerStates.PAUSED && (
                  <IconButton
                    icon='start'
                    type='primary'
                    title='task.item.timeResume'
                    disabled={!canEditInfo}
                    size='normal'
                    canHover={false}
                    className='tasktimming task-resume'
                    onClick={canEditInfo ? this._onResume.bind(this) : null}
                  />
                )}
                {(canAddTimecard || bAssignedUser) &&
                  task.project &&
                  task.activity &&
                  ([timerStates.NONE, timerStates.PAUSED].includes(status)) && (
                    <IconButton
                      icon='time'
                      type='primary'
                      title='task.item.timeAdd'
                      disabled={!canEditInfo}
                      size='normal'
                      canHover={false}
                      className='addtime'
                      onClick={canEditInfo ? this._onAddTime.bind(this) : null}
                    />
                  )}
                {status === timerStates.STARTED ? (
                  <TimeClock
                    type='task'
                    timer={timer}
                    timeSpent={task.timeSpent}
                    stopAndCreateNewTimeCard={
                      this.props.stopAndCreateNewTimeCard
                    }
                  />
                ) : (
                  <span className='time spent'>
                    {task.timeSpent
                      ? Util.convertMinutesToHour(task.timeSpent)
                      : Util.convertMinutesToHour(0)}
                  </span>
                )}
                <span className='time splitter'>/</span>
                <span className='time allocated'>
                  {Util.convertMinutesToHour(this.props.task.duration)}
                </span>
              </div>
            )}
            <div className='cont'>
              <div
                className='description'
                dangerouslySetInnerHTML={{ __html: task.description }}
              />
              <div className='info'>
                {task.project && task.project.contact && (
                  <span className='value'>{task.project.contact.company}</span>
                )}
                {task.project && <span className='split' />}
                <span className='value'>
                  {task.project ? task.project.title : ''}
                </span>
                {phaseTitle && <span className='split' />}
                <span className='value'>{phaseTitle}</span>
                {task.activity && <span className='split' />}
                <span className='value'>
                  {task.activity ? task.activity.title : ''}
                </span>
              </div>
            </div>
          </div>
          <div className='colright'>
            {expanded ? (
              <div className='actions'>
                {noSubTasks > 0 && <span className='count'>{noSubTasks}</span>}
                <IconButton
                  icon='arrow-up'
                  iconSize='12'
                  canHover
                  className='task-collapse'
                  onClick={this._onToggleExpand.bind(this, false)}
                />
              </div>
            ) : (
              <div className='actions'>
                {noSubTasks > 0 && (
                  <span className='count count_alt'>{noSubTasks}</span>
                )}
                <IconButton
                  icon='arrow-down'
                  iconSize='12'
                  canHover
                  className='task-expand'
                  onClick={this._onToggleExpand.bind(this, true)}
                />
              </div>
            )}
          </div>
        </div>
        <div className='subtasks'>{this._renderSubtasks()}</div>
      </div>
    )
  }

  /* Event Handler */
  _onToggleExpand (bExpand, ev) {
    ev.preventDefault()
    ev.stopPropagation()

    const task = this.data.task
    if (bExpand && this._canEditInfo()) {
      task.subtasks.push(this._createEmptySubtask(task))
    } else {
      // Remove empty rows
      _.remove(task.subtasks, obj => !obj.title)
    }

    this.setState({ expanded: bExpand })
  }

  _onUpdateSubtask (_subtask, _idx) {
    const task = this.data.task
    const newSubtasks = this._getSaveObjectSubtasks(task.subtasks)

    this.props.onUpdateSubTasks(task.id, newSubtasks)
  }

  _onDeleteSubtask (subtask, idx, ev) {
    ev.preventDefault()

    const task = this.data.task
    task.noSubTasks--
    _.remove(task.subtasks, (obj, objIdx) => objIdx === idx)

    const newSubtasks = this._getSaveObjectSubtasks(task.subtasks)
    this.props.onUpdateSubTasks(task.id, newSubtasks)
    this._refresh()
  }

  _onUpdateSubtaskEditable (subtask, idx, _ev) {
    const task = this.data.task
    if (idx === task.subtasks.length - 1) {
      task.noSubTasks++
      task.subtasks.push(this._createEmptySubtask(task))
      this._refresh()
    } else {
      task.subtasks[idx + 1].editable = 'title'
      this.setState({ dataDate: new Date() })
    }
  }

  _onCompleteTask () {
    const task = this.data.task
    task.completed = !task.completed
    if (this.props.onCompleteTask) {
      let totalScheduleHrs = 0
      if (task.schedules && task.schedules.length > 0) {
        task.schedules.map(schedule => {
          totalScheduleHrs += schedule.noHours
        })
      }

      const nonTrackedMinutes = totalScheduleHrs * 60 - task.timeSpent
      this.props.onCompleteTask(task, nonTrackedMinutes)
    }
  }

  _onAddTime (ev) {
    ev.stopPropagation()

    if (this.props.onAddTime) {
      this.props.onAddTime(this.data.task)
    }
  }

  _onStart (ev) {
    ev.stopPropagation()

    if (this.props.onStart) {
      this.props.onStart(this.data.task)
    }
  }

  _onPause (ev) {
    ev.stopPropagation()

    if (this.props.onPause) {
      this.props.onPause()
    }
  }

  _onResume (ev) {
    ev.stopPropagation()

    if (this.props.onResume) {
      this.props.onResume()
    }
  }

  _onCompleteSubTask (subtask, _ev) {
    subtask.completed = !subtask.completed
    if (this.props.onUpdateSubTasks) {
      const newSubtasks = this._getSaveObjectSubtasks(this.data.task.subtasks)
      this.props.onUpdateSubTasks(this.data.task.id, newSubtasks)
    }
  }

  /* Private function */
  _onClick = _ev => {
    const { task, onClick } = this.props
    if (onClick) {
      onClick(task)
    }
  }

  _onClickSetting (e) {
    e.preventDefault()
    e.stopPropagation()

    if (this.props.onClickSetting) {
      const canEditAll = this._canEditAll()
      const taskInfo = {
        task: this.data.task,
        canEdit: canEditAll,
        isPhaseClosed: this._isPhaseClosed()
      }
      this.props.onClickSetting(taskInfo)
    }
  }

  _refresh () {
    this.setState({ dataDate: new Date() })
  }

  _getSaveObjectSubtasks (subtasks) {
    const newSubtasks = _.cloneDeep(subtasks)

    // Remove empty rows
    _.remove(newSubtasks, obj => !obj.title)

    newSubtasks.map(obj => {
      delete obj.editable
    })

    return newSubtasks
  }

  _createEmptySubtask (_task) {
    return {
      editable: 'title',
      title: '',
      completed: false
    }
  }

  _renderSubtasks () {
    if (this.data.task.subtasks) {
      return this.data.task.subtasks.map((subtask, idx) => {
        return (
          <TaskSubtask
            key={idx}
            subtask={subtask}
            disableEdit={!this._canEditInfo()}
            onComplete={this._onCompleteSubTask.bind(this, subtask)}
            onUpdate={this._onUpdateSubtask.bind(this, subtask, idx)}
            onDelete={this._onDeleteSubtask.bind(this, subtask, idx)}
            onUpdateEditable={this._onUpdateSubtaskEditable.bind(
              this,
              subtask,
              idx
            )}
          />
        )
      })
    }

    return ''
  }

  _canEditAll () {
    const { loggedInUserId } = this.props
    const { task } = this.data

    // If Phase is closed or completed, edit not allowed
    if (this._isPhaseClosed()) return false

    // If project manager can edit all
    if (Acl.isRoleProjectManager()) return true

    // If current user created this task, can edit all
    if (task.createdById === loggedInUserId) return true

    return false
  }

  _canEditInfo () {
    // If user can edit all info
    if (this._canEditAll()) return true

    const { loggedInUserId } = this.props
    const { task } = this.data

    // If Phase is closed or completed, edit not allowed
    if (this._isPhaseClosed()) return false

    // If current user is the assignee, can edit infos
    return task.userId === loggedInUserId
  }

  _getPhase (task) {
    if (
      task.activity &&
      task.project &&
      task.project.budget &&
      task.project.budget.phases
    ) {
      return task.project.budget.phases[task.activity.phaseNo - 1]
    }

    return null
  }

  _getNoOfSubtasks (subtasks) {
    let noSubTasks = 0
    subtasks.forEach(subTask => {
      if (subTask.title) {
        noSubTasks += 1
      }
    })
    return noSubTasks
  }

  _isPhaseClosed () {
    const phase = this._getPhase(this.data.task)
    return phase && (phase.status === 'closed' || phase.status === 'completed')
  }
}

export default TaskItem
